module.exports = "<svg width=\"10\" height=\"12\" viewBox=\"0 0 10 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.55597 4.58427H9.72739C9.87787 4.58427 10 4.70508 10 4.85393V11.7303C10 11.8792 9.87787 12 9.72739 12H0.272613C0.122131 12 0 11.8792 0 11.7303V4.85393C0 4.70508 0.122131 4.58427 0.272613 4.58427H1.44403V3.51748C1.44403 1.57793 3.03923 0 5 0C6.06421 0 7.02072 0.464822 7.67296 1.2L6.48263 2.10911C6.10812 1.7235 5.58184 1.48315 5 1.48315C3.86607 1.48315 2.94341 2.39582 2.94341 3.51748V4.58427H7.05659H8.55597Z\" fill=\"#4ADE47\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/lock-open.svg
// module id = 868
// module chunks = 0